var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeparateChecks = function SvgSeparateChecks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6h2M6 9h2m8 4.714h2m-2 3h2M3 13.286V4.143A1.143 1.143 0 0 1 4.143 3h5.714A1.143 1.143 0 0 1 11 4.143v9.143L9 12l-2 1.286L5 12l-2 1.286ZM13 21v-9.143a1.143 1.143 0 0 1 1.143-1.143h5.714A1.143 1.143 0 0 1 21 11.857V21l-2-1.286L17 21l-2-1.286L13 21Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSeparateChecks;